import { React, useState } from "react";
import { CiPlay1 } from "react-icons/ci";
import RenderNestedServices from "./RenderNestedServices";
import { NavLink } from "react-router-dom";
// made for the service button in the services page option bar , may be reused later in other pages else should be renamed to servicebutton/link
function OptionBarServiceButton(props) {
  const { option, icon, forms } = props;

  // console.log(service);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  return (
    <li key={option.serviceId}>
      <div className="d-flex align-items-baseline gap-1">
        {(option.subServices && option.subServices.length > 0) ||
        (option.forms != undefined && option.forms.length > 0) ? (
          <p className={`list-arrow ${isOpen ? "is-open" : ""}`}>
            {<CiPlay1 size={12} onClick={handleClick} />}
          </p>
        ) : (
          <p className={"hidden-arrow"}>{<CiPlay1 size={12} />}</p>
        )}
        {icon}
        <p className={`nested-list-item`}>
          <NavLink to={"/services/" + option.serviceId}>{option.name}</NavLink>
        </p>
      </div>
      {((option.subServices && option.subServices.length > 0) ||
        (option.forms != undefined && option.forms.length > 0)) && (
        <RenderNestedServices
          isOpen={isOpen}
          options={option.subServices}
          forms={option.forms}
          icon={icon}
        />
      )}
    </li>
  );
}

export default OptionBarServiceButton;
